import React, { useContext, useEffect } from "react";
import { OptionHeader } from "../../../../../../../type";
import { QuestionsContext } from "../../../../../../../provider/MyContexts";

export function useItemHeader() {
  const [headersLocal, setHeadersLocal] = React.useState<OptionHeader[]>([]);

  const { updateQuestionValue, selectedQuestion } = useContext(QuestionsContext);

  const optionLength = selectedQuestion.options.length;

  function addHeader() {
    const newHeader: OptionHeader = {
      label: `見出し${headersLocal.length + 1}`,
      from: headersLocal[headersLocal.length - 1]?.to + 1 || 1,
      to: optionLength,
    };
    updateQuestionValue("optionHeaders", [...headersLocal, newHeader]);
  }

  function deleteHeader(index: number) {
    const newHeaders = headersLocal.filter((_, i) => i !== index);
    updateQuestionValue("optionHeaders", newHeaders);
  }

  function handleChangeHeader(
    index: number,
    handleType: "label" | "from" | "to",
    value: string | number
  ) {
    const newHeaders = headersLocal.map((header, i) => {
      if (i === index) {
        return {
          ...header,
          [handleType]: handleType === "label" ? value : Number(value),
        };
      }
      return header;
    });
    updateQuestionValue("optionHeaders", newHeaders);
  }

  useEffect(() => {
    // setHeadersLocal(headers);
    if (selectedQuestion && selectedQuestion.optionHeaders.length) {
      setHeadersLocal(selectedQuestion.optionHeaders);
    } else {
      setHeadersLocal([]);
    }
  }, [selectedQuestion]);

  return {
    headersLocal,
    addHeader,
    deleteHeader,
    handleChangeHeader,
  };
}
